import { render } from "./EditBaseWeightModal.vue?vue&type=template&id=7f3bbb2e&scoped=true"
import script from "./EditBaseWeightModal.vue?vue&type=script&lang=js"
export * from "./EditBaseWeightModal.vue?vue&type=script&lang=js"

import "./EditBaseWeightModal.vue?vue&type=style&index=0&id=7f3bbb2e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3bbb2e"]])

export default __exports__